import { TokenService } from "../../services/storage.service";

import * as consts from "../constants/user";
import * as types from "../types.js";
import router from "../../router";
import store from "../store";

import User from "../../services/api-calls/user/user.service";

const state = {
	accessToken: TokenService.getConfig("token"),
	isLoggedIn: false,
	role: TokenService.getConfig("role"),
	twoFactor: TokenService.getConfig("authentication"),
	email: TokenService.getConfig("email"),
	organisationName: TokenService.getConfig("organisation"),
	userID: TokenService.getConfig("id"),
};

const actions = {
	//LOGIN
	async [consts.ACTION_LOGIN]({ commit }, payload) {
		try {
			router.push("/onboarding");
			commit(consts.IS_LOGGED_IN, true);
			commit(consts.SET_USER_CONFIG, payload);
			return true;
		} catch (error) {
			commit(consts.IS_LOGGED_IN, false);
			throw error;
		}
	},

	//Check if logged in
	[consts.ACTION_IS_LOGGED_IN]({ commit }, payload) {
		commit(consts.IS_LOGGED_IN, payload);
	},
	//LOGOUT
	[consts.ACTION_LOGOUT]({ commit }) {
		User.logout();
		store.dispatch(consts.ACTION_IS_LOGGED_IN, false);
		commit(consts.LOGOUT_SUCCESS);
		router.push("/");
	},
};

const mutations = {
	//Set user settings
	[consts.SET_USER_CONFIG]: (state, config) => {
		state.email = config.email;
		state.accessToken = config.token;
		state.organisationName = config.organisation;
		state.role = config.role;
		state.userID = config.id;
	},

	//Check if logged in
	[consts.IS_LOGGED_IN]: (state, payload) => {
		state.isLoggedIn = payload;
	},

	//Clear user settgings
	[consts.LOGOUT_SUCCESS]: (state) => {
		state.accessToken = "";
		state.role = "";
		state.email = "";
		state.organisationName = "";
		state.twoFactor = "";
	},
};

export default {
	// namespaced: true,
	state,
	actions,
	mutations,
	// getters
};
